export default __webpack_public_path__ + "static/media/User profile.938f47e3.svg";